import { useEffect, useRef } from 'react';
import { debounce, throttle, type ThrottleOptions } from '~/utils/debounce';

export function useThrottle<Args extends any[]>(fn: (...args: Args) => void, delay = 100, options?: ThrottleOptions) {
  const throttledRef = useRef(null as any as typeof fn);

  if (throttledRef.current === null) {
    throttledRef.current = throttle(fn, delay, options);
  }

  useEffect(() => {
    throttledRef.current = throttle(fn, delay, { leading: options?.leading });
  }, [fn, delay, options?.leading]);

  return throttledRef.current;
}

export function useDebounce<Args extends any[]>(fn: (...args: Args) => void, delay = 100) {
  const debouncedRef = useRef(null as any as typeof fn);

  if (debouncedRef.current === null) {
    debouncedRef.current = debounce(fn, delay);
  }

  useEffect(() => {
    debouncedRef.current = debounce(fn, delay);
  }, [fn, delay]);

  return debouncedRef.current;
}
